import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['modal', 'panel', 'form', 'title']

  connect() {
    this._onKey = (e) => { if (e.key === 'Escape') this.close() }
  }

  disconnect() {
    document.removeEventListener('keydown', this._onKey)
    document.body.style.overflow = ''
  }

  open(e) {
    if (e) e.preventDefault()
    const btn = e.currentTarget
    this.formTarget.action = btn.dataset.loseUrl
    if (this.hasTitleTarget) this.titleTarget.textContent = btn.dataset.loseTitle || ''
    this.modalTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
    document.addEventListener('keydown', this._onKey)
    const first = this.modalTarget.querySelector('select, textarea, input:not([type=hidden])')
    if (first) setTimeout(() => first.focus(), 30)
  }

  close(e) {
    if (e) e.preventDefault()
    this.modalTarget.classList.add('hidden')
    document.body.style.overflow = ''
    document.removeEventListener('keydown', this._onKey)
  }

  backdrop(e) {
    if (!this.panelTarget.contains(e.target)) this.close()
  }
}
